<template>
    <div style="margin-left: 45px;">
        <el-form :model="form"   ref="form"  >
            <el-form-item label="订单类型：" prop="radio" >
                <el-radio-group v-model="form.type" :disabled="is_disabled || is_edit"  @change="changeType">
                    <el-radio v-model="form.type" label="1">试用</el-radio>
                    <el-radio v-model="form.type" label="2">新增</el-radio>
                    <el-radio v-model="form.type" label="3">续费</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="产品开关：">
                <el-switch
                        :disabled="is_edit"  
                        @change="changeState"
                        v-model="form.is_enable"
                        active-text="开启"
                        inactive-text="关闭">
                </el-switch>
            </el-form-item>
            <el-form-item label="开始时间：">
                <el-date-picker
                        v-model="form.start_at"
                        @change="changeStartAt"
                        :disabled="is_disabled"
                        type="date"
                        placeholder="选择日期"
                        value-format="timestamp"
                        format="yyyy 年 MM 月 dd 日">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间：">
                <el-date-picker
                        @change="changeEndAt"
                        :disabled="is_disabled"
                        v-model="form.end_at"
                        type="date"
                        placeholder="选择日期"
                        value-format="timestamp"
                        format="yyyy 年 MM 月 dd 日">
                </el-date-picker>
                <span style="color: red" v-if="params.isEdit">不支持修改产品时间,想延长 <a href="javascript:void(0)" @click="clickMe" style="color: #1890ff">点我</a></span>
            </el-form-item>
            <el-form-item v-if="params.product_id!=103 && params.product_id!=105  && params.product_id!=14 && params.product_id!=4 && params.product_id!=6 && params.product_id!=5 && params.product_id!=11 && params.product_id!=1"  label="备注："> <!--为啥不统一用这个基础模板的备注，因为产品说备注要放在最底下，用这个模板备注就放在中间了-->
                <el-input
                        style="width: 300px"
                        @change="changeMemo"
                        type="textarea"
                        :rows="2"
                        placeholder="请输入内容"
                        v-model="form.memo">
                </el-input>
            </el-form-item>


        </el-form>
    </div>
</template>
<script>
    import CustomerService from "~/services/customer";
    export default {
        props:{
            params:{
                require:true
            },
            
            is_edit: {
                type: Boolean,
                default: false,
            }
        },
        created(){
            if(this.Acs('/order/supervisorProduct')){
                this.is_disabled = false;
            }
            if(typeof this.params != 'undefined'){
                this.form.type = this.params.open_state;
                this.form.start_at = this.params.start_at;
                this.form.end_at = this.params.end_at;
                this.form.is_enable = this.params.is_enable;
                this.form.memo = this.params.config && typeof this.params.config.memo != "undefined"?this.params.config.memo:'';
                this.emit();
            }
        },
        data() {
            return {
                input_size: 'mini',
                is_disabled:true,
                form: {
                    type: '',
                    start_at:'',
                    end_at:'',
                    is_enable:true,
                    memo:''
                },
                formLabelWidth: '0px',
            };
        },
        methods:{
            changeState(state){
                let  title = state?"开启":"关闭";
                this.$confirm('此操作将'+title+'产品服务, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    CustomerService.productSwitch({customer_id:this.params.customer_id,code:this.params.product_code,is_enable:state,type:this.form.type}).then(res=>{
                        if(res.code){
                            this.form.is_enable = !state;
                            this.$message({type:'error',message:res.msg});
                            return true;
                        }
                        this.form.is_enable = state;
                        this.$message(title+'成功');
                        return true;
                    })
                }).catch(() => {
                    this.form.is_enable = !state;
                });
            },
            /**
             * 修改结束时间
             * @param data
             */
            changeEndAt(data){
                this.emit()
            },
            /**
             * 修改备注
             * */
            changeMemo(){
                this.emit()
            },
            /**
             * 修改开始时间
             * @param data
             */
            changeStartAt(data){
                this.emit()
            },
            /**
             * 修改产品类型
             * @param data
             */
            changeType(data){
                this.emit()
            },
            emit(){
                this.$emit('changeHead',this.form);
            },
            clickMe()
            {
                this.$router.push({
                    path: "/order/create?"+'customer_id='+this.$route.query['id'],
                    query: {
                        referer: this.$route.path
                    }
                });
            }

        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/partial/product_head.vue